import React, { useEffect } from "react";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/CloseSharp";
import CheckIcon from "@material-ui/icons/Check";
import { mapping_order } from "../../../../helpers/constant/mapping";
import { getLabel } from "./labels.logic";

const DisplayNamesForm = ({
    values,
    handleChange,
    handleSubmit,
    handleCancel
}) => {
    /**
     * The page scrolls down when form loads as there are
     * many form fields being dynamically rendered.
     * The below code makes sure the page
     * does not scroll down when new provider is selected and
     * a new form is rendered!
     */
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="mappingField-form">
            <fieldset className="custom-fieldset flow-content">
                <form onSubmit={handleSubmit} className="flow-content--small">
                    <div className="mappingField-form__row mappingField-form__row--header">
                        <h3>Database Column</h3>
                        <h3>Display Name</h3>
                    </div>
                    {mapping_order.map((field) => {
                        return (
                            <div key={field} className="mappingField-form__row">
                                <div>{getLabel(field)}</div>
                                <div>
                                    <FormControl fullWidth>
                                        <TextField
                                            variant="outlined"
                                            label={getLabel(field)}
                                            name={field}
                                            value={values[field]?.value || ""}
                                            error={values[field]?.error}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            placeholder={`Enter Equivalent Display Name`}
                                            type={values[field]?.type}
                                        />
                                        {values[field]?.error && (
                                            <FormHelperText>{values[field].errorMsg}</FormHelperText>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        );
                    })}
                    <div className="profile__basic-info__form__buttons">
                        <Button
                            color="primary"
                            variant="contained"
                            size="medium"
                            startIcon={<CheckIcon />}
                            type="submit"
                        >
                            Save
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleCancel}
                            startIcon={<CloseIcon />}
                        >
                            Cancel
                        </Button>
                    </div>
                </form>
            </fieldset>
        </div>
    );
};

DisplayNamesForm.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    formTouched: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired
};

export default DisplayNamesForm;
